<template>
  <div class="card p-2">
    <div class="table-responsive" style="min-height: 400px">
      <table class="table">
        <thead>
        <tr>
          <th>Location Name</th>
          <th>Product Name(s)</th>
          <th>Requisition Number(s)</th>
          <th>Total Count</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="data && data.length > 0">
          <tr v-for="(group, index) in data" :key="index">
            <td>{{ group.location_name || 'N/A' }}</td>
            <td>{{ group.product_names || 'N/A' }}</td>
            <td>{{ group.requisition_numbers || 'N/A' }}</td>
            <td class="text-center">{{ group.total_count || 0 }}</td>
            <td>
              <button 
                class="btn btn-sm btn-primary" 
                @click="viewItem(group)"
              >
                View
              </button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
      <p v-if="!data || data.length === 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['onView']);

const viewItem = (group) => {
  emit('onView', group);
};
</script>
